/**
 * Cờ cho `ReferralPromptDialog`: "vừa đăng nhập" (sessionStorage, dùng một lần) và
 * "không hiện lại" theo tài khoản (localStorage). Tách khỏi file component để
 * `login.tsx` import được mà không phá fast refresh.
 */

const PENDING_KEY = "boide_ref_prompt_pending";
const NEVER_PREFIX = "boide_ref_prompt_never:";

export function markReferralPromptPending(): void {
  try {
    sessionStorage.setItem(PENDING_KEY, "1");
  } catch {
    /* private mode — bỏ qua, popup chỉ là lời mời */
  }
}

export function takePending(): boolean {
  try {
    const has = sessionStorage.getItem(PENDING_KEY) === "1";
    if (has) sessionStorage.removeItem(PENDING_KEY);
    return has;
  } catch {
    return false;
  }
}

function neverKey(username: string) {
  return `${NEVER_PREFIX}${username}`;
}

export function isNever(username: string): boolean {
  try {
    return localStorage.getItem(neverKey(username)) === "1";
  } catch {
    return false;
  }
}

export function setNever(username: string): void {
  try {
    localStorage.setItem(neverKey(username), "1");
  } catch {
    /* ignore */
  }
}
